/**
 * Suomen kiinteät pyhäpäivät (backlog 2.12).
 *
 * Arkipäivälaskenta on odotetun työajan nimittäjä kolmessa paikassa:
 * laskutusasteessa ja sen tavoitteessa (12.6), lukituksen tarkistuslistassa
 * (6.3) ja kalenterin täyttöasteessa (10). Ilman pyhiä jokainen niistä
 * vinoutuu samaan suuntaan — joulukuu näyttää muita heikommalta, koska
 * kahtena päivänä ei ollut mahdollista tehdä työtä.
 *
 * **Vain kiinteät päivät.** Liikkuvat pyhät — pitkäperjantai, toinen
 * pääsiäispäivä, helatorstai ja juhannusaatto — lasketaan pääsiäisestä,
 * eikä sitä sääntöä ole tässä. Ne osuvat kaikki arkipäivälle, joten
 * huhtikuu, toukokuu ja kesäkuu jäävät toistaiseksi yhtä vinoiksi kuin
 * ennen. `movingHolidaysInYear`in lisääminen tähän tiedostoon riittäisi:
 * `isHoliday` on ainoa paikka, jota kuluttajat kutsuvat.
 *
 * **Jouluaatto on mukana**, vaikka se ei ole virallinen pyhäpäivä. Se on
 * työehtosopimuksissa vapaapäivä, eikä kukaan kirjaa sille tunteja — ja
 * odotus, joka on eri asia kuin todellisuus, on juuri tämän korjauksen
 * kohde. Uudenvuodenaatto sen sijaan on työpäivä, eikä se ole listalla.
 *
 * Nimet ovat suomeksi kuten muukin palvelimen tuottama teksti (backlog 2.8);
 * käyttöliittymä ei toistaiseksi näytä niitä, mutta laskennan tarkistaminen
 * ilman nimeä on päivämäärien lukemista kalenterista.
 */
/**
 * Kiinteät pyhäpäivät kuukauden ja päivän mukaan.
 *
 * Järjestys on kalenterin, ei tärkeyden: lista luetaan silmällä, ja
 * vuoden mittainen aikajana on siinä helpoin tarkistaa.
 */
export const FIXED_HOLIDAYS = [
    { month: 1, day: 1, name: 'uudenvuodenpäivä' },
    { month: 1, day: 6, name: 'loppiainen' },
    { month: 5, day: 1, name: 'vappu' },
    { month: 12, day: 6, name: 'itsenäisyyspäivä' },
    { month: 12, day: 24, name: 'jouluaatto' },
    { month: 12, day: 25, name: 'joulupäivä' },
    { month: 12, day: 26, name: 'tapaninpäivä' },
];
/** `"12-24"` → nimi. Rakennetaan kerran, ei joka kutsulla. */
const BY_MONTH_DAY = new Map(FIXED_HOLIDAYS.map((holiday) => [avain(holiday.month, holiday.day), holiday.name]));
function avain(month, day) {
    return `${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}
/**
 * ISO-päivämäärän kuukausi ja päivä ilman jäsennystä.
 *
 * `parseIsoDate` olisi luonteva, mutta se on `time.ts`:ssä, joka kutsuu
 * tätä tiedostoa — ja kehäriippuvuus toimisi ESM:ssä muttei ansaitse
 * olemassaoloa viiden merkin viipaleen takia. Tyyppituonti on eri asia:
 * se katoaa käännöksessä.
 */
function kuukausiPaiva(date) {
    return date.slice(5, 10);
}
/**
 * Pyhäpäivän nimi, tai `null` jos päivä on tavallinen.
 *
 * Vuosi ei vaikuta mihinkään: kiinteä pyhä on samana päivänä joka vuosi,
 * eikä sitä siirretä arkipäiväksi, jos se osuu viikonlopulle. Suomessa ei
 * ole Britannian kaltaista siirtokäytäntöä — viikonlopulle osunut pyhä
 * yksinkertaisesti menetetään, ja niin se menetetään tässäkin.
 */
export function holidayName(date) {
    return BY_MONTH_DAY.get(kuukausiPaiva(date)) ?? null;
}
export function isHoliday(date) {
    return holidayName(date) !== null;
}
//# sourceMappingURL=holidays.js.map